export const getMainMenuStyles = (mainMenu, { palette = {} }) => ({
  mainMenuContainer: {
    transition: 'width 0.2s',
    display: 'flex',
    flexDirection: 'column',
    width: '100%',
    flex: '1 1 1px',
  },
  hidden: {
    display: 'none',
  },
  menuList: {
    listStyle: 'none',
    paddingTop: 8,
    // borderTop: `solid 1px ${palette.neutralQuaternaryAlt}`,
  },
  divider: {
    borderTop: `solid 1px ${palette.mainMenuHoverBackground}`,
  },
  majorComponentsContainer: {
    borderTop: 'none',
  },
  container: {
    display: 'flex',
    height: '100%',
    position: 'static',
  },
});

export const getMenuItemListStyles = () => ({
  menuList: {
    '.static-list-wrapper &': {
      borderTop: 'none',
    },
    listStyle: 'none',
  },
  menuListBorder: {
    borderTop: 'solid 1px #484644',
  },
  groupHeader: {
    marginLeft: 12,
    marginTop: 10,
    marginBottom: 8,
  },
  recentReportsLabel: {
    margin: '10px 16px',
    fontSize: '12px',
  },
  recentReportLightLabel: {
    color: '#FFFFFF',
  },
});
